'use client'
import { usePageReadinessTelemetry } from '@brew/observability/browser'
import { usePathname, useSearchParams } from 'next/navigation'
import { type ReactNode, Suspense } from 'react'
import { pageCommit } from '@/lib/observability/page-commit'
import type { PAGE_COMMIT_CONTRACTS } from '@/lib/observability/page-commit-contracts'

type Props = {
  pageKey: keyof typeof PAGE_COMMIT_CONTRACTS
  children?: ReactNode
}
function Observer({ pageKey }: Pick<Props, 'pageKey'>) {
  const pathname = usePathname()
  const search = useSearchParams()
  usePageReadinessTelemetry(pageCommit, {
    surface: pageKey,
    pathname: pathname ?? '',
    search: search?.toString() ?? '',
    state: 'ready',
    enabled: pathname !== null,
  })
  return null
}
/** Only the observer suspends on URL data; page content keeps its original boundaries. */
export function PageCommit({ pageKey, children }: Props) {
  return (
    <>
      {children}
      <Suspense fallback={null}>
        <Observer pageKey={pageKey} />
      </Suspense>
    </>
  )
}
